export const DIGITAL_LOAN_INTERNAL_PREVIEW_KEY = 'digitalLoanInternalPreview';

export const DIGITAL_LOAN_PREVIEW_TAP_COUNT = 10;
export const DIGITAL_LOAN_PREVIEW_TAP_WINDOW_MS = 5000;

export function hasDigitalLoanInternalPreview() {
  try {
    return sessionStorage.getItem(DIGITAL_LOAN_INTERNAL_PREVIEW_KEY) === '1';
  } catch {
    return false;
  }
}

export function unlockDigitalLoanInternalPreview() {
  try {
    sessionStorage.setItem(DIGITAL_LOAN_INTERNAL_PREVIEW_KEY, '1');
  } catch {
    // Ignorar si sessionStorage no está disponible.
  }
}

export function clearDigitalLoanInternalPreview() {
  try {
    sessionStorage.removeItem(DIGITAL_LOAN_INTERNAL_PREVIEW_KEY);
  } catch {
    // Ignorar si sessionStorage no está disponible.
  }
}

export function isDigitalLoanProductionGateActive() {
  return process.env.NODE_ENV === 'production';
}

/** Detecta destinos internos del flujo Digital Loan (usado por CmsLink). */
export function isDigitalLoanPreviewTarget(target) {
  if (!target || typeof target !== 'string') {
    return false;
  }

  if (target.startsWith('http://') || target.startsWith('https://')) {
    return false;
  }

  const path = target.split(/[?#]/)[0];

  if (path === '/digital-loan') {
    return true;
  }

  return path.startsWith('/digital-loan/');
}
